import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { ReactComponent as BackLeftIcon } from "src/assets/icons/back-left.svg";
import { ReactComponent as DismissOtherIcon } from "src/assets/icons/close-WS.svg";
import { ROUTE_PATHS } from "src/utils/constants";
import useResponsive from "src/utils/useResponsive";
import { getClassnames } from "src/utils/utils";
import { getLogoComponent, HeaderProps } from "../utils/Navigation.utils";
import "./zara-header.scss";

const ZaraHeader = ({ wrapperProps }: HeaderProps) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { WSXL } = useResponsive();
  const { showBackIcon, handleBackClick, handleDimissClick, onLogoClickHandled,} = wrapperProps;

  const classNameNavBar = getClassnames({
    ["nav-zds-main-menu"]: pathname?.includes(`${ROUTE_PATHS.PRODUCTS}/`),
    ["nav-zds"]: true,
  });

  const LogoZara = getLogoComponent("zara", WSXL);

  const iconMap = {
    back: (
      <BackLeftIcon
          className="nav-zds__icons__header-icon__svg"
          onClick={() => handleBackClick()}
        />
    ),
    dismiss: (
      <DismissOtherIcon
          className="nav-zds__icons__header-icon__svg"
          onClick={() => handleDimissClick()}
        />
    ),
  };

  const Icon = showBackIcon() ? iconMap.back : iconMap.dismiss;

  return (
    <nav className={classNameNavBar} aria-label={t("navigation_main")}>
      <ul className="nav-zds__header">
        <li>{Icon}</li>
        <li className="nav-zds__icons__icon">
          <LogoZara onClick={onLogoClickHandled} aria-label="Logo" />
        </li>
      </ul>
    </nav>
  );
};

export default ZaraHeader;
